module.exports = __webpack_public_path__ + "img/汽车天窗2.9485ae92.jpg";